import type { ContentTab } from "~/componentsDS/ContentTabs";

import WhatItIsContent from "./WhatItIsContent";
import BodymatchedTotalValueContent from "./BodymatchedTotalValueContent";
import OestraTotalValueContent from "./OestraTotalValueContent";

export const TOTAL_VALUE_BODYMATCHED_TABS: ContentTab[] = [
    {
        value: "what-it-is",
        label: "WHAT IT IS",
        content: <WhatItIsContent />,
    },
    {
        value: "bodymatched-total-value",
        label: "BODYMATCHED® TOTAL VALUE",
        content: <BodymatchedTotalValueContent />,
    },
];

export const TOTAL_VALUE_OESTRA_TABS: ContentTab[] = [
    {
        value: "what-it-is",
        label: "WHAT IT IS",
        content: <WhatItIsContent />,
    },
    {
        value: "oestra-total-value",
        label: <>OESTRA<sup>®</sup> TOTAL VALUE</>,
        content: <OestraTotalValueContent />,
    },
];
